// extracted by mini-css-extract-plugin
export default {"workersListSection":"styles_workersListSection__Bi2di","sectionTitle":"styles_sectionTitle__XgBIZ","tradeTitle":"styles_tradeTitle__92S5C"};